import React from "react";
import "../index.scss";
import { MdCampaign } from "react-icons/md";

export const CampaignCard = () => {
  return (
    <div style={{ flex: 1, padding: "15px 0px" }}>
      <div className="in-progress-card-container">
        <div className="in-progress-card-icon">
          <MdCampaign style={{ fill: "#eea125", width: 40, height: 40 }} />
        </div>
        <div>
          <div style={{ fontSize: 18, fontWeight: "bold" }}>Bloco de campanha</div>
          <div style={{ color: "rgb(163, 163, 163)" }}>
            Banner promocional que pode conter imagem ou vídeo.
          </div>
          <div style={{ color: "rgb(163, 163, 163)" }}>
            {/* xxx. */}
          </div>
        </div>
      </div>
    </div>
  );
};
